<template>
  <div id="app">
    <div class="header">
      <headerAll></headerAll>
    </div>
    <div style="text-align: center;background-color: #295ad0;border-bottom-left-radius: 50%;border-bottom-right-radius: 50%">
      <img src="../../images/bg.png" style="position: relative;top:30px" alt="">
    </div>
    <div style="border: 1px solid #9BB4EC;padding: 10px;border-radius:10px;height: 40px;width: 80%;margin: 80px auto 20px auto">
      <div style="float: left;text-align: center">
        <img src="../../images/bb.png" style="position: relative;left: 10px;top: 2px" alt="">
        <div style="width: 1px;height:40px;background-color: #c9c9c9;float: right;margin-left: 30px"></div>
      </div>
      <div style="float: left;margin-left: 30px">
        <p style="margin-top: 0;margin-bottom: 5px;font-family: '黑体'">版本号</p>
        <span style="color: #999;font-size: 13px;font-family: '黑体'">{{ content.version }}</span>
      </div>
    </div>
    <div style="border: 1px solid #9BB4EC;padding: 10px;border-radius:10px;height: 40px;width: 80%;margin: 0 auto">
      <div style="float: left;text-align: center">
        <img src="../../images/phone.png" style="position: relative;left: 10px;top: 2px" alt="">
        <div style="width: 1px;height:40px;background-color: #c9c9c9;float: right;margin-left: 30px"></div>
      </div>
      <div style="float: left;margin-left: 30px">
        <p style="margin-top: 0;margin-bottom: 5px;font-family: '黑体'">联系方式</p>
        <span style="color: #999;font-size: 13px;font-family: '黑体'">{{content.phone}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import headerAll from "../module/header.vue"
import {aboutUs} from "../common/api/about";
import jump from "../common/jump";

export default {
  name: "about",
  data(){
    return{
      content:[]
    }
  },
  components:{headerAll},
  mounted(){
    aboutUs().then( res => {
      this.content = res.data
    })
  },
  methods:{

    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>
.inpu{
  background-color: #EAEAEA ;
  border: none;
  border-radius: 20px;
  /*height: 28px;*/
  font-size: 12px;
  padding: 10px;
  letter-spacing: 1px;
  font-family: '黑体';
  float: left;
  width: 60%;
  margin-left: 10px;
  margin-top:10px
}
.van-button {
  float: right;
  margin-right: 10px;
  background-color: #5B8DFD ;
  border-radius: 20px;
  margin-top:10px
}
.foot{
  width:90%;
  margin:50px auto;
  background-color: #fff;
  border-radius: 10px;
}

</style>